import React from "react";
import EcokazAfrica from "../../img/ecokaz_africa.png";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-gray-900 tracking-wide px-5 md:px-12 lg:px-32 xl:px-40 2xl:px-60 py-8 md:py-12 lg:py-16">
      <div className="lg:flex lg:items-center my-5">
        <a href="ecokaz.vercel.app">
          <img src={EcokazAfrica} alt="Logo Ecoka for Africa" />
        </a>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h4 className="text-2xl poppins-bold mb-3 text-white text-center pb-2 border-b-2 border-b-white">
            PRODUITS
          </h4>
          <ul className="space-y-2">
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                Brique lego - ECOBRIKS
              </span>
              <div className="items-center grid grid-cols-10 gap-x-1">
                <p className="text-sm text-gray-300 poppins-regular col-span-9">
                  Facile à mettre en place, rapide, étanche et résistant aux
                  chocs avec une durée de vie plus de 50 ans.
                </p>
                <div className="flex items-center justify-center rounded-full h-11 w-11 text-xs bg-lime-400 poppins-bold text-black">
                  25RS
                </div>
              </div>
            </li>
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                Chaise - ECOSEZA
              </span>
              <div className="items-center grid grid-cols-10 gap-x-1">
                <p className="text-sm text-gray-300 poppins-regular col-span-9">
                  Une chaise pliable, peut supporter une charge de 120 Kg avec
                  une durée de vie plus de 50 ans.
                </p>
                <div className="text-black flex items-center justify-center rounded-full h-11 w-11 text-xs bg-lime-400 poppins-bold">
                  350RS
                </div>
              </div>
            </li>
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                Carreaux - ECOKARO
              </span>
              <div className="items-center grid grid-cols-10 gap-x-1">
                <p className="text-sm text-gray-300 poppins-regular col-span-9">
                  Carreaux murales / douches. Résistant à l'eau et facile à
                  mettre en oeuvre.
                </p>
                <div className="text-black flex items-center justify-center rounded-full h-11 w-11 text-xs bg-lime-400 poppins-bold">
                  50RS
                </div>
              </div>
            </li>
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                Tuiles - ECOKAPILA
              </span>
              <div className="items-center grid grid-cols-10 gap-x-1">
                <p className="text-sm text-gray-300 poppins-regular col-span-9">
                  Tuile isolant, étanche et résistant aux chocs.
                </p>
                <div className="text-black flex items-center justify-center rounded-full h-11 w-11 text-xs bg-lime-400 poppins-bold">
                  50RS
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-2xl poppins-bold mb-3 text-white text-center pb-2 border-b-2 border-b-white">
            SERVICES
          </h4>
          <ul className="space-y-2">
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                FORMATION DES OUVRIERS
              </span>
              <p className="text-sm text-gray-300 poppins-regular">
                Nous assistons gratuitement notre clients avec notre responsable
                technique.
              </p>
            </li>
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                LIVRAISON GRATUIS
              </span>
              <p className="text-sm text-gray-300 poppins-regular">
                Pour votre commande, nous livrons les produits gratuitement.
              </p>
            </li>
            <li>
              <span className="text-pink-600 hover:text-white text-lg poppins-semibold">
                PROMOTION POUR LES MEMBRES
              </span>
              <p className="text-sm text-gray-300 poppins-regular">
                En étant membre, vous bénéficiez des promotions avecdes remises
                de 10%.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-x-32 gap-y-5 text-gray-100 mt-16 poppins-regular">
        <span className="py-2 group">
          Ensemble pour l'Afrique
          <div class="bg-pink-600 h-[4px] w-0 group-hover:w-full transition-all duration-500"></div>
        </span>
        <span className="py-2 group">
          Ensemble pour la durabilité
          <div class="bg-pink-600 h-[4px] w-0 group-hover:w-full transition-all duration-500"></div>
        </span>
        <span className="py-2 group text-center">
          Ensemble pour notre maison commune
          <div class="bg-pink-600 h-[4px] w-0 group-hover:w-full transition-all duration-500"></div>
        </span>
      </div>

      <div class="mb-4 flex items-center justify-center space-x-4 mt-8">
        <a
          href="https://web.facebook.com/profile.php?id=61560310173070"
          target="_blank"
          type="button"
          class="text-pink-600 bg-pink-200 flex items-center rounded-full p-2 leading-normal transition-all duration-300 hover:scale-110 ease-in-out"
          data-twe-ripple-init
        >
          <FaFacebookF size={20} />
        </a>
      </div>

      <p className="text-gray-300 text-sm text-center">
        © 2024
        <a
          href="ecokaz.vercel.app"
          target="_blank"
          className="hover:underline mx-1"
        >
          ECOKAZ
        </a>
        Tous droits réservés.
      </p>
    </footer>
  );
}

export default Footer;
